import { render, staticRenderFns } from "./pvalue.vue?vue&type=template&id=f6b71cf0&scoped=true&v-once=true"
import script from "./pvalue.vue?vue&type=script&lang=js"
export * from "./pvalue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b71cf0",
  null
  
)

export default component.exports